(function () {
  function initReveal(root = document) {
    const els = Array.from(root.querySelectorAll('[data-reveal]'));
    if (!('IntersectionObserver' in window) || !els.length) {
      // fallback simples
      els.forEach(el => el.classList.add('in-view'));
      return;
    }

    const io = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          // Para reanimar sempre que sair/entrar, comente a linha abaixo:
          obs.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '0px 0px -10% 0px', // dispara um tico antes do final da viewport
      threshold: 0.15
    });

    els.forEach(el => io.observe(el));
  }

  /* fix-301 (2026-09-02) — A REVELACAO NAO PODE ESPERAR O DOMContentLoaded.
     -------------------------------------------------------------------------------
     Este arquivo era, sem que ninguem tivesse notado, o que punha o app do Profit
     Pumper no caminho critico de renderizacao da PDP. A cadeia, medida em 2026-09-02:

       1. o app embed `profit-pumper-bundles` injeta no <head>
          `<script defer src=".../pumper-bundles.js">` — 423,8 KB;
       2. um script `defer` ADIA o DOMContentLoaded ate terminar de baixar; em 4G
          Lighthouse (1,6 Mbps / 150 ms) ele so termina aos ~14.990 ms, porque disputa
          banda com os 3,3 MB da pagina;
       3. o UNICO elemento `.reveal` da PDP e o <slideshow-container> da galeria, ou
          seja, o container que contem a IMG do LCP;
       4. `.reveal` nasce com `opacity: 0` em base.css e so ganha `.in-view` aqui;
       5. logo, a imagem do LCP tinha os bytes aos ~8.600 ms e so PINTAVA aos
          ~15.350 ms — 6,7 s parada esperando um arquivo de app que nada tem a ver
          com ela.

     Medido na URL publicada, 7 amostras por braco, os tres bracos pelo MESMO caminho
     de acesso (metodo de qa-reports/2026-09-02-metodo-lcp-pedagio-do-preview.md):

       com o app                 LCP mediana 15.356 ms   CLS 0,0642
       sem o JS do app           LCP mediana  2.404 ms   CLS 0,0005
       sem o JS e sem o CSS      LCP mediana  2.192 ms   CLS 0,0005

     O app CONTINUA carregando, ativo e visivel — ele responde pelo preco promocional
     dos kits e por 30% dos pedidos da loja, e nao pode ser removido nem desativado.
     O que muda aqui e so isto: a galeria deixa de esperar por ele para aparecer.

     Este arquivo e carregado no FIM do <body> (layout/theme.liquid), entao tudo que
     `initReveal` precisa ja foi parseado quando esta linha roda. */
  initReveal(document);

  /* rede de seguranca: pega o que for parseado ou inserido depois deste ponto.
     Chamar duas vezes e inofensivo — o observer marca `in-view` (idempotente) e da
     `unobserve` no elemento em seguida. */
  document.addEventListener('DOMContentLoaded', () => initReveal(document));

  // re-inicializa ao inserir/editar sections no Theme Editor
  document.addEventListener('shopify:section:load', (e) => initReveal(e.target));
  document.addEventListener('shopify:section:select', (e) => initReveal(e.target));
})();
